<template>
    <card-normal
        without-padding
        style="border-width: 2px"
        :border-color="'gray-200'"
    >
        <flex-container
            direction="column"
            padding="sm"
            gap="md"
        >
            <flex-container
                justify-content="space-between"
            >
                <bar-skeleton
                    :width="480"
                    :height="50"
                />
                <bar-skeleton
                    :width="120"
                    :height="20"
                />
            </flex-container>
            <flex-container
                class="assistent-card-skeleton__layers"
                justify-content="space-between"
                no-wrap
            >
                <bar-skeleton
                    :width="0"
                    :height="100"
                />
                <bar-skeleton
                    :width="0"
                    :height="100"
                />
                <bar-skeleton
                    :width="0"
                    :height="100"
                />
                <bar-skeleton
                    :width="0"
                    :height="100"
                />
            </flex-container>
        </flex-container>
    </card-normal>
</template>

<style scoped lang="scss">
    .assistent-card-skeleton {
        &__layers {
            :deep(.animated-gradient) {
                border-top-right-radius: size(lg);
                border-bottom-right-radius: size(lg);
            }
        }
    }
</style>
